/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/import-whitelist
import { NOT_FOUND } from '@jira/platform__http-status-codes/src/http-status-codes.tsx';
import { getProjectKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import {
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch';

// We use 1/0 to reduce characters as user preferences has a 255 limit
export type IssueCollapsibleGroupData = {
	1: string[]; // expanded group ids
	0: string[]; // collapsed group ids
};

const getKey = ({ match, query }: { match: Match; query: Query }) => {
	const projectKey = getProjectKey(match, query);
	return `issue.collapsible-group.${projectKey}`;
};

export const issueCollapsibleGroupDataResource: RouteResource<
	IssueCollapsibleGroupData | undefined
> = createResource<IssueCollapsibleGroupData | undefined>({
	type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
	getKey,
	getData: async ({ match, query }) => {
		const key = getKey({ match, query });
		const requestUrl = `/rest/api/3/mypreferences?key=${key}`;

		try {
			return await performGetRequest(requestUrl);
		} catch (error) {
			if (
				!!error &&
				typeof error === 'object' &&
				'statusCode' in error &&
				error.statusCode === NOT_FOUND
			) {
				return;
			}

			throw createResourceError(
				{
					component: 'spa.view.routes.issue-view.collapsible-group.getData',
					message: 'An error was thrown while prefetching issue collapsible group data',
				},
				error,
			);
		}
	},
});
